import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Button, TextInput, ActionIcon, Alert, Group, Stack, Box, Title, Text } from "@mantine/core";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import Cookies from "js-cookie";

export default function AuthForm(props: {
  setSecretReady: Dispatch<SetStateAction<boolean>>;
}) {
  const { REACT_APP_API_URL } = process.env;
  const [keyAuth, setKeyAuth] = useState("");
  const [invalid, setInvalid] = useState(false);
  const [show, setShow] = useState(false);

  const handleClick = () => setShow(!show);
  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    setKeyAuth(event.target.value);

  const processRequest = async () => {
    setInvalid(false);
    const targetURL = REACT_APP_API_URL + "token";
    const response = await fetch(targetURL, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ key: keyAuth }),
    });

    const res = await response.json();

    if (response.status !== 200) {
      setInvalid(true);
    } else {
      Cookies.set("access_token", res.access_token);
      props.setSecretReady(true);
    }
  };

  return (
    <Box style={{ maxWidth: 400, margin: 'auto', padding: 20, border: '1px solid #ddd', borderRadius: 8, marginTop: 50 }}>
      <Stack gap={16}>
        <Title order={2}>Authenticate</Title>
        <Text>Please introduce the authentication key</Text>
        <TextInput
          placeholder="Enter key"
          type={show ? "text" : "password"}
          value={keyAuth}
          onChange={handleChange}
          rightSection={
            <ActionIcon onClick={handleClick} variant="subtle">
              <FontAwesomeIcon icon={show ? faEyeSlash : faEye} />
            </ActionIcon>
          }
        />
        {invalid && (
          <Alert title="Error" color="red">
            Something went wrong
          </Alert>
        )}
        <Group justify="flex-end">
          <Button color="blue" onClick={processRequest}>
            Enter
          </Button>
        </Group>
      </Stack>
    </Box>
  );
}
